import {SerializedError} from "@reduxjs/toolkit";
import {FetchBaseQueryError} from "@reduxjs/toolkit/query";

import {getAppErrors} from "@pg-mono/request";
import {IAppError} from "@pg-mono/request-state";

export interface IApplicationRtkError {
    appError: IAppError;
    /** HTTP status as string, or a tag like `FETCH_ERROR` when the request never reached a response. */
    errorCode: string;
}

const emptyAppError = (): IAppError => ({status: 0, fieldErrors: {}, nonFieldErrors: []});

/**
 * Normalises an RTK Query rejection into the `IAppError` shape used across lead forms and the
 * `lead_form_error` Amplitude event. Requests that never got a response (network, timeout, parsing)
 * carry no HTTP status, so their RTK tag is reported as the error code instead.
 */
export const getAppErrorFromRtkError = (error: FetchBaseQueryError | SerializedError): IApplicationRtkError => {
    if ("status" in error) {
        if (typeof error.status === "number") {
            return {appError: getAppErrors(error.status, (error.data ?? {}) as Record<string, string[]>), errorCode: String(error.status)};
        }

        // A PARSING_ERROR still knows the HTTP status it failed to parse — typically an HTML error page
        // served by the proxy on 5xx. Report that status rather than hiding a backend outage behind the tag.
        if ("originalStatus" in error && typeof error.originalStatus === "number") {
            return {appError: {status: error.originalStatus, fieldErrors: {}, nonFieldErrors: []}, errorCode: String(error.originalStatus)};
        }

        return {appError: emptyAppError(), errorCode: error.status};
    }

    return {appError: emptyAppError(), errorCode: error.code || error.name || "UNKNOWN_ERROR"};
};
import {SerializedError} from "@reduxjs/toolkit";
import {FetchBaseQueryError} from "@reduxjs/toolkit/query";

import {getAppErrors} from "@pg-mono/request";
import {IAppError} from "@pg-mono/request-state";

export interface IApplicationRtkError {
    appError: IAppError;
    /** HTTP status as string, or a tag like `FETCH_ERROR` when the request never reached a response. */
    errorCode: string;
}

const emptyAppError = (): IAppError => ({status: 0, fieldErrors: {}, nonFieldErrors: []});

/**
 * Normalises an RTK Query rejection into the `IAppError` shape used across lead forms and the
 * `lead_form_error` Amplitude event. Requests that never got a response (network, timeout, parsing)
 * carry no HTTP status, so their RTK tag is reported as the error code instead.
 */
export const getAppErrorFromRtkError = (error: FetchBaseQueryError | SerializedError): IApplicationRtkError => {
    if ("status" in error) {
        if (typeof error.status === "number") {
            return {appError: getAppErrors(error.status, (error.data ?? {}) as Record<string, string[]>), errorCode: String(error.status)};
        }

        // A PARSING_ERROR still knows the HTTP status it failed to parse — typically an HTML error page
        // served by the proxy on 5xx. Report that status rather than hiding a backend outage behind the tag.
        if ("originalStatus" in error && typeof error.originalStatus === "number") {
            return {appError: {status: error.originalStatus, fieldErrors: {}, nonFieldErrors: []}, errorCode: String(error.originalStatus)};
        }

        return {appError: emptyAppError(), errorCode: error.status};
    }

    return {appError: emptyAppError(), errorCode: error.code || error.name || "UNKNOWN_ERROR"};
};
